<ion-header>

  <ion-toolbar>
    <div class="closeBtn">
        <button (click)="closeModal()">
            <ion-icon name="close"></ion-icon>
        </button>
    </div>
    <ion-title>{{collection.getTitle()}}</ion-title>

  </ion-toolbar>

</ion-header>
<!-- <ion-content class="ion-padding"> -->
  <ion-content >
<!-- {{getDescription()}} -->
<!--<img *ngIf="collection.isDictionary()" width="200px" height="200px" src="../../../assets/img/collections/dictionary.gif" />-->
<!--<img  width="180px" height="320" src="../../../assets/img/collections/dictionary.gif" />-->
<!--<div class="collectionImage dictionary">
    hallo
</div>-->
</ion-content>
